"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _constants = require("../utils/constants");

var _lodash = require("lodash");

var _ChoiceImage = _interopRequireDefault(require("./ChoiceImage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Choice = function Choice(_ref) {
  var questionId = _ref.questionId,
      disabled = _ref.disabled,
      choices = _ref.choices,
      multipleAnswers = _ref.multipleAnswers,
      value = _ref.value,
      setValue = _ref.setValue,
      error = _ref.error;

  var handleSetValue = function handleSetValue(val, check) {
    if (!multipleAnswers) {
      setValue([val]);
      return;
    }

    var newValue = [].concat(value, [val]);
    setValue((0, _lodash.uniq)((!check ? newValue.filter(function (x) {
      return x !== val;
    }) : newValue).filter(function (y) {
      return y !== '';
    })));
  };

  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: questionId + "-Choice-FormGroup",
    error: error ? _constants.CHOICE_TYPE_ERROR : ''
  }, choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Checkbox, {
      key: questionId + "-" + choice.id,
      fullWidth: true,
      outlined: true,
      disabled: disabled,
      name: questionId + "-choice-" + choice.id,
      checked: value && value.includes(choice.id),
      value: choice.id,
      onChange: function onChange(e) {
        return handleSetValue(e.target.value, !value.includes(choice.id));
      },
      label: choice.value,
      className: "ln-u-bg-color-white ln-u-margin-bottom survey__checkbox"
    }), /*#__PURE__*/_react.default.createElement(_ChoiceImage.default, {
      image: choice == null ? void 0 : choice.image
    }));
  }))));
};

Choice.propTypes = {
  /** The unique identifier of the question */
  questionId: _propTypes.default.string.isRequired,

  /** The list of choices */
  choices: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the choice */
    id: _propTypes.default.string,

    /** The value of the choice */
    value: _propTypes.default.string,

    /** The optional image associated with a choice */
    image: _propTypes.default.shape({
      fileName: _propTypes.default.string,
      url: _propTypes.default.string,
      type: _propTypes.default.string
    })
  })),

  /** Indicates whether multiple choices can be selected */
  multipleAnswers: _propTypes.default.bool.isRequired,

  /** Indicates whether the question component should be disabled */
  disabled: _propTypes.default.bool,

  /** The response value for this component */
  value: _propTypes.default.array,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the given response */
  error: _propTypes.default.bool
};
Choice.defaultProps = {
  choices: [],
  disabled: false,
  value: [],
  setValue: function setValue() {},
  error: false
};
var _default = Choice;
exports.default = _default;